import React from 'react'

function MyFooter() {
  return (
    <div>Footer</div>
  )
}

export default MyFooter